module.exports = __webpack_public_path__ + "media/printed-materials/image027-116191d8.jpg";